import React from 'react';
import { Skeleton, Select, Tooltip, Form, List, Card, Tabs, Menu, Input, Layout, Row, Col, Icon, Button, Tree, Avatar } from 'antd';
import styled from 'styled-components';

const Title = styled.span`
  vertical-align: middle;
  
  & > button {
    visibility: hidden;
  }

  &:hover {
    button {
      visibility: visible;
    }
  }
`;

const TitleButton = styled(Button)`
  border: none !important;
  display: inline;
  padding: 0;
`;

class EntityNodeTitle extends React.Component {
  handleInspect = (event) => {
    const { id, onInspect } = this.props;
    event.preventDefault();
    event.stopPropagation();
    onInspect(id);
  };

  render() {
    const { children } = this.props;
    return (
      <Title>
        {children}
        <TitleButton onClick={this.handleInspect} icon="select" size="small" shape="circle" ghost/>
      </Title>
    );
  }
}

export default EntityNodeTitle;
